import React from 'react';
import { Calendar } from 'lucide-react';

interface TimeRangeFilterProps {
  value: number;
  onChange: (days: number) => void;
}

export default function TimeRangeFilter({ value, onChange }: TimeRangeFilterProps) {
  return (
    <div className="flex items-center gap-2">
      <Calendar className="w-5 h-5 text-gray-400" />
      <select
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="input bg-dark-800 text-sm"
      >
        <option value={30}>Next 30 days</option>
        <option value={90}>Next 90 days</option>
        <option value={120}>Next 120 days</option>
      </select>
    </div>
  );
}